import React from 'react';

const ReportLevel4Breadcrumb = () => <span>Line Items</span>;

export default ReportLevel4Breadcrumb;
